const elementIdSelector = 'vue-overview-posts';

const overviewVueObject = {
    el: `#${elementIdSelector}`,
    data: function () {
        return {
            posttype: null,
            posts: [],
            foundPosts: 0,
            foundPages: 0,
            loadingPosts: true,
            step: 12,
            postsVisible: 12,
            firstPostBig: false,

            // Search
            searchText: '',

            // Filter terms
            filterTaxonomies: [],
            openedDropdownSlug: '',
            selectedTerms: {}
        };
    },
    methods: {
        isTermSelected(targetedTerm) {
            // console.log('isSelected :', targetedTerm.taxonomy, targetedTerm.term_id);
            const terms = this.selectedTerms[targetedTerm.taxonomy];
            const includesTerm = terms.some((term) => term.slug === targetedTerm.slug);
            return includesTerm;
        },
        loadPosts({ append = false } = {}) {
            this.loadingPosts = true;

            let params = {
                posttype: this.posttype,
                terms: this.selectedTerms,
                posts_visible: this.postsVisible,
                search: this.searchText
            };

            const formData = new FormData();
            formData.append('action', 'get_overview_posts');
            formData.append('data', JSON.stringify(params));

            console.log('loadPosts:', params);

            axios
                .post(wp_ajax.ajax_url, formData)
                .then((response) => {
                    const result = response.data;
                    this.foundPosts = result.found_posts;
                    this.foundPages = result.max_num_pages;

                    if (this.foundPosts >= 1) {
                        if (append) {
                            // Append new posts to existing ones, don't replace
                            const previousPostsLength = this.posts.length;
                            const newPosts = result.posts.slice(previousPostsLength);
                            this.posts.push(...newPosts);
                        } else {
                            // Replace the entire list (used for filters/search)
                            this.posts = result.posts;
                        }
                    } else {
                        this.posts = [];
                    }

                    console.log('loadPosts result :', result);
                    console.log('this.posts :', this.posts);
                    console.log('this.foundPosts :', this.foundPosts);

                    setTimeout(() => {
                        document.body.classList.add('vue-loaded');
                    }, 100);

                    this.loadingPosts = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        loadMorePosts() {
            this.postsVisible += this.step;
            this.loadPosts({ append: true });
        },
        resetAndLoadPosts() {
            // Reset paging state and replace results
            this.postsVisible = this.step;
            this.posts = [];
            this.loadPosts({ append: false });
        },
        clearSearchText() {
            this.searchText = '';
            this.resetAndLoadPosts();
        },
        loadFilterTaxonomies() {
            let params = {
                posttype: this.posttype
            };

            const formData = new FormData();
            formData.append('action', 'get_overview_filter_taxonomies');
            formData.append('data', JSON.stringify(params));

            axios
                .post(wp_ajax.ajax_url, formData)
                .then((response) => {
                    this.filterTaxonomies = response.data;
                    console.log('this.filterTaxonomies :', this.filterTaxonomies);

                    this.filterTaxonomies.forEach((taxonomy) => {
                        this.selectedTerms[taxonomy.slug] = [];
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onDropdownToggle(slug) {
            if (!this.isMobileDevice()) {
                return;
            }
            console.log('onDropdownToggle :', slug);
            if (this.openedDropdownSlug == slug) {
                this.openedDropdownSlug = '';
            } else {
                this.openedDropdownSlug = slug;
            }
            console.log('this.openedDropdownSlug :', this.openedDropdownSlug);
        },
        closeDropdowns(event) {
            // console.log('closeDropdowns :', event.target.classList);
            const excludeClasses = ['dropdown-select', 'dropdown-item', 'filter-item'];
            const targetClasses = [...event.target.classList];
            const closeDropdown = !targetClasses.some((className) => excludeClasses.includes(className));

            if (this.openedDropdownSlug && closeDropdown) {
                document.querySelectorAll('.dropdown-select').forEach((el) => {
                    el.classList.remove('active');
                    this.openedDropdownSlug = '';
                });
            }
        },
        onSelectTerm(term) {
            const taxonomy = term.taxonomy;
            const slug = term.slug;
            console.log('onSelectTerm :', term);

            let terms = this.selectedTerms[taxonomy];
            const termIsPresent = terms.some((term) => term.slug === slug);
            console.log('termIsPresent :', termIsPresent);
            if (termIsPresent) {
                terms = terms.filter((term) => term.slug !== slug);
                // this.removeURLSearchParam(taxonomy, slug);
            } else {
                // terms.push(term);
                terms = [term];
            }

            // console.log('New terms :', terms);
            Vue.set(this.selectedTerms, taxonomy, terms);

            // Trigger change detection
            this.selectedTerms = Object.assign({}, this.selectedTerms);
            this.resetAndLoadPosts();

            console.log('this.selectedTerms', this.selectedTerms);
        },
        clearTerm(taxonomySlug) {
            console.log('clearTerm taxonomySlug :', taxonomySlug);
            Vue.set(this.selectedTerms, taxonomySlug, []);

            // const url = new URL(window.location.href);
            // const currentValues = url.searchParams.getAll(taxonomySlug);
            // currentValues.forEach((valueSlug) => {
            //     this.removeURLSearchParam(taxonomySlug, valueSlug);
            // });

            this.resetAndLoadPosts();
        },
        isMobileDevice() {
            return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
        }
    },
    filters: {},
    mounted: function () {
        this.$nextTick(function () {
            // Get post-type for overview from data attribute
            const overviewElement = document.getElementById(elementIdSelector);
            this.posttype = overviewElement.getAttribute('data-post-type');
            console.log('init overview for posttype:', this.posttype);

            this.loadPosts({ append: false });
            this.loadFilterTaxonomies();
        });
    }
};

const overviewIsPresent = document.getElementById(elementIdSelector);
if (overviewIsPresent) {
    new Vue(overviewVueObject);
}

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // Click was outside the element and his children
            if (!(el == event.target || el.contains(event.target))) {
                // Call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});
